'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import CustomWidgetPropTypes from 'DesignData/propTypes/customWidgets';
import { connect } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import UIFormLabel from 'UIComponents/form/UIFormLabel';
import RichTextPreview from 'DesignEditorsUI/components/shared/inputs/RichTextPreview';
import CustomWidgetField from 'DesignData/models/CustomWidgetField';
import { RICH_TEXT } from 'ContentUtils/constants/CustomWidgetFieldTypes';
import { DEFAULT } from 'DesignData/enums/CustomWidgetFieldAttributes';

const i18nKey = key => `DesignEditorsUI.customWidgetEditor.sidebar.fieldEdit.contentOptions.${key}`;

import * as customWidgetEditorOptionsActions from 'DesignData/actions/CustomWidgetEditorOptions';

function mapStateToProps() {
  return {};
}

const mapDispatchToprops = {
  setFullScreenEditorOpen: customWidgetEditorOptionsActions.setFullScreenEditorOpen
};

class FullScreenEditButton extends PureComponent {
  constructor(...args) {
    super(...args);

    this.openFullScreenEditor = () => {
      this.props.setFullScreenEditorOpen(this.props.customWidgetId, true);
    };
  }

  renderEditButton() {
    const {
      type
    } = this.props.field;
    return /*#__PURE__*/_jsx(UIButton, {
      disabled: this.props.readOnly,
      use: "tertiary-light",
      onClick: this.openFullScreenEditor,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: i18nKey(`${type}.edit`)
      })
    });
  }

  renderRichTextPreview() {
    const {
      field
    } = this.props;
    return /*#__PURE__*/_jsx(RichTextPreview, {
      onClick: this.openFullScreenEditor,
      value: field[DEFAULT] || ''
    });
  }

  renderOption() {
    switch (this.props.field.type) {
      case RICH_TEXT:
        {
          return this.renderRichTextPreview();
        }

      default:
        {
          return this.renderEditButton();
        }
    }
  }

  render() {
    const {
      type
    } = this.props.field;
    return /*#__PURE__*/_jsxs("div", {
      className: "m-y-3",
      children: [/*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsx(UIFormLabel, {
          className: "p-top-0",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: i18nKey(`defaultLabels.${type}`)
          })
        })
      }), this.renderOption()]
    });
  }

}

FullScreenEditButton.propTypes = {
  customWidgetId: CustomWidgetPropTypes.customWidgetId.isRequired,
  setFullScreenEditorOpen: PropTypes.func.isRequired,
  field: PropTypes.instanceOf(CustomWidgetField).isRequired,
  readOnly: PropTypes.bool
};
export default connect(mapStateToProps, mapDispatchToprops)(FullScreenEditButton);